import type { PlaceResult } from '@packages/shared-ui/v4/form';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type DigitalCommerceState = {
  address: PlaceResult | undefined;
};

export const initialState: DigitalCommerceState = {
  address: undefined,
};

export const digitalCommerceSlice = createSlice({
  name: 'DigitalCommerce',
  initialState,
  reducers: {
    setDigitalCommerceAddress: (
      state,
      action: PayloadAction<PlaceResult | undefined>
    ) => {
      state.address = action.payload;
    },
    resetDigitalCommerce: () => {
      return initialState;
    },
  },
  selectors: {
    selectDigitalCommerceAddress: (sliceState) => sliceState.address,
  },
});

export const { setDigitalCommerceAddress, resetDigitalCommerce } =
  digitalCommerceSlice.actions;

export const { selectDigitalCommerceAddress } = digitalCommerceSlice.selectors;

export default digitalCommerceSlice.reducer;
export type DigitalCommerceSlice = typeof digitalCommerceSlice;
